import styled from 'styled-components';

type StyledFooterProps = {
  bgColor?: string;
};

export const StyledFooter = styled.footer<StyledFooterProps>`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : `var(--bg)`)};
`;

export const Container = styled.div`
  padding: 2rem 1.5rem 1rem;
  position: relative;
  max-width: var(--max-width);

  @media (min-width: 1024px) {
    display: flex;
    justify-content: space-between;
    padding: 4rem 2.5rem 3rem;
    margin: auto;
  }

  @media (min-width: 1580px) {
    padding: 4rem 0 3rem;
  }
`;

export const Logo = styled.img`
  position: absolute;
  top: 2rem;
  right: 1.5rem;
  object-fit: contain;

  @media (min-width: 1024px) {
    position: initial;
    width: 192px;
    height: 208px;
    object-position: right;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  &,
  li,
  a {
    color: var(--text-color-secondary);
  }

  li {
    margin-bottom: 1.5rem;
  }

  a {
    transition: color 0.3s ease-in-out;
    &:hover,
    &:focus {
      color: var(--highlight-blue);
    }
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    div {
      flex: 1;
    }
  }
`;

export const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
`;

export const SocialList = styled.ul`
  column-count: 2;
  width: fit-content;
  font-size: 1rem;

  a {
    font-weight: 300;
  }

  @media (min-width: 1024px) {
    column-count: 1;
  }
`;

export const ContactList = styled.ul`
  li {
    margin: 1rem 0;
    font-weight: 300;

    a {
      font-weight: 400;
    }
  }
`;

export const Rights = styled.div`
  font-size: 0.875rem;
  text-align: center;
  color: #6e6e6e;
  border-top: 1px solid var(--text-color);
  padding: 2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Politics = styled.div`
  margin: 0 auto;
  display: flex;
  padding-bottom: 1.5rem;
  a {
    color: #8e8e8e;
    font-size: 1rem;
    padding-bottom: 0.0125rem;
    border-bottom: 1px solid;
  }

  @media (min-width: 1024px) {
    justify-content: center;
  }
`;
